<template>
  <BaseView>
    <HowOtivoMakesMoney />
  </BaseView>
</template>

<script lang="ts" setup>
import BaseView from '@/views/BaseView.vue'
import HowOtivoMakesMoney from '@/app/views/About/HowOtivoMakesMoney.vue'
</script>
